export default __webpack_public_path__ + "static/media/Zealous Atlantean Relic.d5285123.jpg";